/* eslint-disable import/no-default-export */
import {CartIconController} from './Controller/CartIconController';

import {I$WWrapper, IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../constants';

export const controller = (controllerParams: ControllerParams): IWidgetController => {
  const siteStore = controllerParams?.appData?.context.siteStore;
  let controllerClass: CartIconController | undefined;

  const getController = async () => {
    if (controllerClass) {
      return controllerClass;
    }
    if (!controllerParams.controllerConfig.essentials.experiments.enabled(SPECS.StopCallingGetClientConfigInCartIcon)) {
      await siteStore.loadClientConfig();
    }
    controllerClass = new CartIconController(controllerParams);
    return controllerClass;
  };

  return {
    async pageReady() {
      try {
        const controller = await getController();

        await controller.init();
        controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controller.load());
      } catch (error) {
        /* istanbul ignore next */
        console.error(error);
        /* istanbul ignore next */
        controllerParams.controllerConfig.setProps({generalError: true});
        /* istanbul ignore next */
        controllerParams.appData?.reportError(error);
      }
    },
    exports() {
      return getExportsAfterControllerLoaded(getController, ['addToCart', 'addProductsToCart']);
    },
    updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
      return void controllerClass?.onStyleUpdate?.(updatedConfig.style.styleParams, updatedConfig.publicData);
    },
    updateAppSettings: (_$w: I$WWrapper, updates: {[key: string]: any}): void => {
      return void controllerClass?.onAppSettingsUpdate?.(updates);
    },
    onBeforeUnLoad() {
      return controllerClass?.onBeforeUnLoad?.();
    },
  };
};
function getExportsAfterControllerLoaded(getController: () => Promise<CartIconController>, keys: string[]) {
  return keys.reduce((acc, key) => {
    acc[key] = async (...args: any[]) => {
      const controllerClass = await getController();
      return controllerClass.exports()[key](...args);
    };
    return acc;
  }, {});
}

export default controller;
